
// /Users/apichet/Downloads/cheetah-insurance-app/frontend/src/api/tokenUtils.js
// /src/api/tokenUtils.js
import { jwtDecode } from "jwt-decode";



const AUTH_TOKEN_KEY = "authToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const USER_ROLE_KEY = "userRole";

// ==================== Getters ====================
export const getAuthToken = () => {
  try {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const getRefreshToken = () => {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
};

export const getUserRole = () => {
  try {
    return localStorage.getItem(USER_ROLE_KEY);
  } catch {
    return null;
  }
};

// ==================== Savers ====================
export const saveAuthToken = (token) => {
  if (!token) return;
  try {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  } catch {
    // eslint-disable-next-line no-console
    console.warn("⚠️ Failed to save auth token");
  }
};

export const saveRefreshToken = (token) => {
  if (!token) return;
  try {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  } catch {
    console.warn("⚠️ Failed to save refresh token");
  }
};

export const saveUserRole = (role) => {
  if (!role) return;
  try {
    localStorage.setItem(USER_ROLE_KEY, role);
  } catch {
    console.warn("⚠️ Failed to save user role");
  }
};

// ==================== Clear ====================
export const clearTokens = () => {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_ROLE_KEY);
  } catch {
    console.warn("⚠️ Failed to clear tokens");
  }
};

// ==================== Helpers ====================
export const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};
